import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b6b899a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-matiere-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un parent")
], -1))
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4 mb-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom du parent "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Prénom du parent"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = { class: "col-md-4 mb-3" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Numéro NPI "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-4 mb-3" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Téléphone 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone 2 ", -1))
const _hoisted_27 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de naissance ", -1))
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Pays de naissance "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Commune "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Quartier "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_42 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "border border-primary mb-1" }
const _hoisted_45 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-white" }, "Pièce(s)")
], -1))
const _hoisted_47 = { class: "col-md-5" }
const _hoisted_48 = { class: "d-flex float-end" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row gx-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
      /*#__PURE__*/_createTextVNode(" Type de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode(" Numéro de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode(" Image "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Action ")
  ])
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_52 = { class: "col-md-4 mb-3" }
const _hoisted_53 = { class: "modern-select-group" }
const _hoisted_54 = { class: "col-md-4 mb-3" }
const _hoisted_55 = { class: "modern-input-group" }
const _hoisted_56 = { class: "col-md-3 mb-3" }
const _hoisted_57 = { class: "form-group mb-0" }
const _hoisted_58 = {
  key: 0,
  class: "col-md-1 mb-3"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-0 position-relative top-1" }, null, -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "col-md-12 mt-3" }
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = {
  ref: "submitButton",
  class: "btn btn-success me-3",
  type: "submit"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        ref: "parentForm",
        onSubmit: _ctx.addParent,
        "validation-schema": _ctx.parentSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  name: "nom",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nom",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "prenom",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le prenom"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "prenom",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Field, {
                  name: "npi",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le numéro npi"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "npi",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  name: "email",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'email"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  name: "sexe",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: ['Masculin', 'Féminin'],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "sexe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, {
                  name: "telephone1",
                  modelValue: _ctx.telephone1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telephone1) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _ctx.validate,
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (!_ctx.validPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Veuillez entrer un numéro correcte"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone1",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Field, {
                  name: "telephone2",
                  modelValue: _ctx.telephone2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telephone2) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _ctx.validate,
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (!_ctx.validPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Veuillez entrer un numéro correcte"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone2",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_Field, {
                  name: "dateNaissance",
                  type: "date",
                  max: _ctx.currentDate,
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["max"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateNaissance",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_Field, {
                  name: "nationalite",
                  modelValue: _ctx.nationalite,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nationalite) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.countries,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le pays de résidence" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_Field, {
                  name: "commune",
                  modelValue: _ctx.commune,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.commune) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.communeOptions,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.communeChange($event))),
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.selectedCommune,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCommune) = $event))
                    }, field, { placeholder: "Sélectionner la commune" }), null, 16, ["options", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "commune",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_Field, {
                  name: "quartier",
                  modelValue: _ctx.quartier,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.quartier) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.quartierOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.selectedQuartier,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedQuartier) = $event))
                    }, field, {
                      noOptionsText: "Sélectionner d'abord une commune",
                      placeholder: "Sélectionner le quartier"
                    }), null, 16, ["options", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "quartier",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                              type: "button",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addRowPiece()))
                            }, [
                              _hoisted_49,
                              _createTextVNode(" Ajouter une pièce ")
                            ], 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_50,
                        _hoisted_51,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row gx-1",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_Field, {
                                  name: `pieces[${index}].typePiece`
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_Multiselect, _mergeProps({
                                      modelValue: _ctx.pieces[index].typePiece,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.pieces[index].typePiece) = $event),
                                      ref_for: true
                                    }, field, {
                                      options: _ctx.typeOptions,
                                      "preserve-search": true,
                                      multiple: false,
                                      searchable: true,
                                      placeholder: "Sélectionner le type de pièce",
                                      label: "label",
                                      "track-by": "value",
                                      class: "modern-multiselect"
                                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["name"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: `pieces[${index}].typePiece`,
                                  class: "text-danger"
                                }, null, 8, ["name"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  class: "form-control shadow-none fs-md-15 text-black modern-input",
                                  placeholder: "Entrer le numéro de la pièce",
                                  name: `pieces[${index}].numeroPiece`
                                }, null, 8, ["name"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: `pieces[${index}].numeroPiece`,
                                  class: "text-danger"
                                }, null, 8, ["name"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_component_Field, {
                                  type: "file",
                                  accept: "image/*",
                                  class: "form-control",
                                  onChange: ($event: any) => (_ctx.handleFileChange($event, index)),
                                  name: `pieces[${index}].urlImage`
                                }, null, 8, ["onChange", "name"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: `pieces[${index}].urlImage`,
                                  class: "text-danger"
                                }, null, 8, ["name"])
                              ])
                            ]),
                            (index > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger transition border-0 py-1 px-2",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeRowPiece(index))
                                  }, _hoisted_61, 8, _hoisted_59)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("button", _hoisted_64, " Ajouter un parent ", 512),
                _createVNode(_component_router_link, {
                  to: "/liste-parents",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_65,
                    _hoisted_66,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}